import css from './MultiEvent.module.scss'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { IEventData } from 'meta/pages/v4/event'
import { IEventPerformerRoleData } from 'meta/pages/v4/performer'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'

import SingleEvent from '../SingleEvent'

interface Props {
  eventData: IEventData
  list: IEventPerformerRoleData[]
}

const MultiEvent: React.FC<Props> = (props) => {
  const { eventData, list } = props

  const { t } = useTranslation()

  const [showPerformers, setShowPerformers] = useState<boolean>(false)

  return (
    <div className={css.multiEventContainer}>
      <div className={css.eventDetails} onClick={() => setShowPerformers(!showPerformers)}>
        <div className={css.left}>
          <img
            className={css.image}
            alt={eventData.name}
            src={eventData.assets?.find((x) => x.format == 'SQUARE')?.url}
          />

          <div className={css.text}>
            <div className={css.name}>{eventData.name}</div>
            <div className={css.date}>{Dates.format(eventData.dateEvent.date_tz, t('dates:common:collection'))}</div>
          </div>
        </div>
        <div className={css.right}>
          <div className={classNames(css.arrow, { [css.isOpen]: showPerformers })}>
            {!showPerformers && <Img src="/arrows/black-down.svg" />}
            {showPerformers && <Img src="/arrows/white-up.svg" />}
          </div>
        </div>
      </div>

      {showPerformers && (
        <div className={css.singleEventContainer}>
          <SingleEvent list={list} addTime={Boolean(list.find((x) => Boolean(x.time) === true))} insideMulti />
        </div>
      )}
    </div>
  )
}

export default MultiEvent
